import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("api/plt/password");


const logoutAsync = (params) => {
    return remoteCall.invoke("logout", params);
};

const updateAsync = (params) => {
    return remoteCall.invoke("update", params);
};

const updateForceAsync = (params) => {
    return remoteCall.invoke("updateForce", params);
};


const setConfigAsync = (params) => {
    return remoteCall.invoke("setConfig", params);
};

const resetAsync = (param) => {
    return remoteCall.invoke("reset", param);
};

export default {
    logoutAsync,
    updateAsync,
    updateForceAsync,
    setConfigAsync,
    resetAsync,
};
